/* eslint no-restricted-syntax:0, no-restricted-globals:0, max-len:0, no-global-assign:0 */
import {
  webviewInfo
} from '@ali/amap-lib';
import actConfig from './config.act';
//* 接口名称
const AOS_NAME = actConfig.aosName;

// nodejs 环境
if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
  location = {
    protocol: 'http:'
  };
}

const AOS_URL = Object.create(Object.create(null, {
  aosName: {
    value: AOS_NAME
  }
})); // output
const AOS_PRE_DEV = '//sns.testing.amap.com/ws/acs/'; //* 测试环境接口域名
const AOS_PRE_PUBLIC = '//sns.amap.com/ws/acs/'; //* 正式环境接口域名

const AOS_URL_GROUP = {
  index: { // 领券首页
    test: '//maps.testing.amap.com/ws/car-promotion/external/activity/index',
    public: '//m5.amap.com/ws/car-promotion/external/activity/index'
  },
  token: { // 领券首页带奖品
    test: '//maps.testing.amap.com/ws/car-promotion/external/activity/token/detail',
    public: '//m5.amap.com/ws/car-promotion/external/activity/token/detail'
  },
  transport: { // 端外领券运力信息(新)
    test: '//maps.testing.amap.com/ws/car-promotion/external/activity/transport',
    public: '//m5.amap.com/ws/car-promotion/external/activity/transport'
  },
  verify: {// 端外获取验证码
    test: '//sns.testing.amap.com/ws/oss/newtaxi/coupon/external/verify',
    public: '//sns.amap.com/ws/oss/newtaxi/coupon/external/verify'
  },
  get_new: {// 领券接口 包含验证码
    test: '//maps.testing.amap.com/ws/car-promotion/external/get-new',
    public: '//m5.amap.com/ws/car-promotion/external/get-new'
  },
  get: {// 领券接口 不包含验证码
    test: '//maps.testing.amap.com/ws/car-promotion/external/get',
    public: '//m5.amap.com/ws/car-promotion/external/get'
  },
  download: { // 下载接口
    test: '//maps.testing.amap.com/ws/car-promotion/external/download-url',
    public: '//m5.amap.com/ws/car-promotion/external/download-url'
  },
  /*
  运营活动通用接口
   */

  transform: {// 转短链
    test: '//m5.amap.com/ws/mapapi/shortaddress/transform',
    public: '//m5.amap.com/ws/mapapi/shortaddress/transform',
  },
  voucher: {// 提现问卷
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/voucher',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/voucher'
  },
  question_submit: { // 问卷提交
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/voucher_submit',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/voucher_submit'
  },
  owner_cash_to_wallet: { // 钱包提现
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/withdraw-cash',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/withdraw-cash'
  },
  address: { // 编辑地址
    test: '//sns.testing.amap.com/ws/acs/activity_base/owner/address-edit',
    public: '//sns.amap.com/ws/acs/activity_base/owner/address-edit'
  },
  // 分享文案及配置
  share_share_conf: {
    test: '//sns.testing.amap.com/ws/oss/activity_base/share/share-conf',
    public: '//sns.amap.com/ws/oss/activity_base/share/share-conf',
  },
  // 口令
  share_command: {
    test: '//sns.testing.amap.com/ws/oss/operation/share-code',
    public: '//sns.amap.com/ws/oss/operation/share-code'
  },
  // base64生成图片
  create_image: {
    test: '//sns.testing.amap.com/ws/oss/activity_base/create_image',
    public: '//sns.amap.com/ws/oss/activity_base/create_image',
  },
};

const DEV_HOST = window.location.protocol + AOS_PRE_DEV + AOS_NAME;
const ONLINE_HOST = window.location.protocol + AOS_PRE_PUBLIC + AOS_NAME;
const HOST = !webviewInfo.isPublic() ? DEV_HOST : ONLINE_HOST;

for (const k in AOS_URL_GROUP) {
  if (AOS_URL_GROUP[k].test) {
    AOS_URL[k] = window.location.protocol + (!webviewInfo.isPublic() ? AOS_URL_GROUP[k].test : AOS_URL_GROUP[k].public);
  } else {
    AOS_URL[k] = `${HOST}/${AOS_URL_GROUP[k]}`;
  }
}

export default AOS_URL;
